import React, { useState } from 'react'
import Wizard from '../../shared/Wizard'
import Panel from '../../shared/Panel'
import Steps from './Steps'

import { STEPS } from '../../../constants/newHome'

import styles from './NewHomeWizard.module.scss'

const NewHomeWizard = ({ createHome, complete }) => {
  const [home, setHome] = useState()

  return (
    <Panel className={styles.root}>
      <Wizard provider initialStep={STEPS.HOME_ADDRESS}>
        <Wizard step={STEPS.HOME_ADDRESS}>
          <Steps.EnterAddress onAddress={setHome} />
        </Wizard>
        <Wizard step={STEPS.HOME_PURCHASE_DATE}>
          <Steps.EnterPurchaseDate onPurchaseDate={() => createHome(home)} />
        </Wizard>
        <Wizard step={STEPS.HOME_CREATE}>
          <Steps.CreateHome />
        </Wizard>
      </Wizard>
    </Panel>
  )
}

export default NewHomeWizard
